import React from 'react'
import InfiniteSlider from './infinite-slider.component'
import StoreProductOverview from './../../../components/store-product/store-product-overview.component'
import * as config from 'config'
import { isMobile } from './../../../services/breakpoints.service'

const baseUrl = `${config.contentUrl}loja/produto/`

class MoveflexStoreSlider extends React.Component {
	render() {
		return (
			<InfiniteSlider
				itemsPerPage={isMobile() ? 1 : 5}
				data={this.props.items}
				renderItem={(
					{
						productId,
						points,
						pointsForSubscribers,
						productName,
						imageName,
						priceNotMember,
						priceForMember
					},
					index
				) => {
					return (
						<StoreProductOverview
							key={index}
							id={productId}
							points={points}
							name={productName}
							src={`${baseUrl}${imageName}`}
							pointsForSubscribers={pointsForSubscribers}
							priceNotMember={priceNotMember}
							priceForMember={priceForMember}
						/>
					)
				}}
			/>
		)
	}
}

export default MoveflexStoreSlider
